<template>
    <div class="text-base text-black dark:text-white dark:bg-slate-900 layout_landing" :class="current_mode" :dir="$page.props.dir">
        <top-nav />
        <flash-messages />
        <slot />
        <footer-section v-if="$page.props.footer" :footer="$page.props.footer" />
        <a
            id="back-to-top"
            @click="topFunction"
            href="javascript:void(0)"
            class="back-to-top flex fixed hidden bottom-5 right-5 left-auto z-[999] h-10 w-10 items-center justify-center rounded-md bg-primary text-white shadow-md transition duration-300 ease-in-out hover:bg-dark"
        >
            <span class="mt-[6px] h-3 w-3 rotate-45 border-t border-l border-white"></span>
        </a>
    </div>
</template>

<script>
import TopNav from '@/Shared/Landing/TopNav'
import FooterSection from '@/Shared/Landing/FooterSection'
import FlashMessages from '@/Shared/FlashMessages'

export default {
    components: {
        TopNav,
        FooterSection,
        FlashMessages,
    },
    data() {
        return {
            current_mode: 'light',
        }
    },
    methods: {
        scrollFunction() {
            const mybutton = document.getElementById('back-to-top')
            if (mybutton != null) {
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    mybutton.classList.add('block')
                    mybutton.classList.remove('hidden')
                } else {
                    mybutton.classList.add('hidden')
                    mybutton.classList.remove('block')
                }
            }
        },
        topFunction() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
    },
    created() {
        const vm = this
        window.onscroll = function () {
            vm.scrollFunction()
        }
        const saved = localStorage.getItem('current_mode')
        if (saved) {
            this.current_mode = saved
            document.documentElement.className = this.current_mode
        }
    },
}
</script>
